  import { createContext, useContext, useState, useEffect } from "react";
  import axios from "axios";

  const AuthContext = createContext();

  export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
      const savedUser = localStorage.getItem("weThriftUser");
      if (savedUser) {
        setUser(JSON.parse(savedUser));
      }
      setLoading(false);
    }, []);

   const login = async (email, password) => {
  try {
    const res = await axios.post(
      "https://wethrift-backend.onrender.com/api/auth/login",
      { email, password }
    );

    if (res.data && res.data.accessToken) {
      setUser(res.data);
      localStorage.setItem("weThriftUser", JSON.stringify(res.data));
      return { success: true, user: res.data };
    }
    return { success: false, message: "Handshake Failed" };
  } catch (err) {
    return { success: false, message: err.response?.data?.message || "Access Denied" };
  }
};

const verifyOtp = async (email, otp) => {
  try {
    // URL ko /verify-otp se badal kar /verify-otp-combined kar diya hai
    const res = await axios.post(
      "https://wethrift-backend.onrender.com/api/auth/verify-otp-combined", 
      { email, otp }
    );

    if (res.data && res.data.accessToken) {
      setUser(res.data);
      localStorage.setItem("weThriftUser", JSON.stringify(res.data));
      return { success: true, user: res.data };
    }
    
    return { success: false, message: "Verification Failed" };
  } catch (err) {
    console.error("OTP Verification Error:", err.response?.data);
    return { 
      success: false, 
      message: err.response?.data?.message || "Invalid Security Code" 
    };
  }
};
    const logout = () => {
      setUser(null);
      localStorage.removeItem("weThriftUser");
      window.location.href = "/auth";
    };

    return (
      <AuthContext.Provider value={{ user, loading, login, logout, verifyOtp }}>
        {!loading && children}
      </AuthContext.Provider>
    );
  };

  export const useAuth = () => useContext(AuthContext);